var styles = {
  "Container": "Polaris-Filters__Container",
  "SearchField": "Polaris-Filters__SearchField",
  "FiltersWrapper": "Polaris-Filters__FiltersWrapper",
  "hideQueryField": "Polaris-Filters--hideQueryField",
  "FiltersInner": "Polaris-Filters__FiltersInner",
  "AddFilter": "Polaris-Filters__AddFilter",
  "FiltersWrapperWithAddButton": "Polaris-Filters__FiltersWrapperWithAddButton",
  "AddFilterActivatorMultiple": "Polaris-Filters__AddFilterActivatorMultiple",
  "FiltersStickyArea": "Polaris-Filters__FiltersStickyArea",
  "ClearAll": "Polaris-Filters__ClearAll",
  "MultiplePinnedFilterClearAll": "Polaris-Filters__MultiplePinnedFilterClearAll"
};

export { styles as default };
